export default __webpack_public_path__ + "static/eight-dad5256d3ebd8f4a3cc1a04f77d96f20.jpg";